import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './previazaneTerminyMobileTableItem.scss';
import routes from '../../../../routing/routes';

interface Props {
  termin: string,
  typVztahu: string,
  tezaurus: string,
  uuid: string,
}

const PreviazaneTerminyMobileTableItem = ({
  termin,
  typVztahu,
  tezaurus,
  uuid,
}: Props): ReactElement => (
  <Col className="previazane-terminy-detail">
    <Row className="previazane-terminy-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Termín
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Link to={routes.tezaurus.detail.withParams(uuid)}>{termin}</Link>
      </div>
    </Row>
    <Row className="previazane-terminy-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Typ vzťahu
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{typVztahu}</Text>
      </div>
    </Row>
    <Row className="previazane-terminy-detail-row">
      <div className="one-third">
        <Text type="span" className="information-header">
          <div className="information-header-row">
            Tezaurus
          </div>
        </Text>
      </div>
      <div className="two-thirds">
        <Text type="p" className="dokument-detail-row-text">{tezaurus}</Text>
      </div>
    </Row>
  </Col>
);

export default PreviazaneTerminyMobileTableItem;
